import React, { useState, useEffect, useRef } from 'react';
import GongshiStyles from './Gongshi.module.css';
import ConfettiPopup from './ConfettiPopup';
import FiveWord from './FiveWord.jpg';
import SevenWord from './SevenWord.jpg';
const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

const Gongshi = () => {
  const [showConfetti, setShowConfetti] = useState(false);
  const [isFiveWordLine, setIsFiveWordLine] = useState(true);
  const [poemUnits, setPoemUnits] = useState(Array(20).fill(''));
  const [submittedPoem, setSubmittedPoem] = useState('');
  const [assessmentResult, setAssessmentResult] = useState('');
  const [modelAssessment, setModelAssessment] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [placeholderText, setPlaceholderText] = useState('');
  const [showBadgePrompt, setShowBadgePrompt] = useState(false);
  const [currentLevel, setCurrentLevel] = useState('');
  const [submissions, setSubmissions] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSubmission, setSelectedSubmission] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [hasGongshiBadge, setHasGongshiBadge] = useState(false);
  const videoRef = useRef(null);
  const [pingZeFeedback, setPingZeFeedback] = useState('');
  const placeholderContent = 'Type here...';

  useEffect(() => {
    const token = localStorage.getItem('token');
    setIsLoggedIn(!!token);

    if (token) {
      fetchUserLevel(token);
    }
  }, []);

  useEffect(() => {
    if (!poemUnits[0]) {
      let index = 0;
      const interval = setInterval(() => {
        setPlaceholderText(placeholderContent.substring(0, index));
        index = (index + 1) % (placeholderContent.length + 1);
      }, 200);
      return () => clearInterval(interval);
    }
  }, [poemUnits]);

  useEffect(() => {
    if (showBadgePrompt && videoRef.current) {
      videoRef.current.play();
    }
  }, [showBadgePrompt]);

  const handleToggle = () => {
    setIsFiveWordLine(!isFiveWordLine);
    setPoemUnits(Array(!isFiveWordLine ? 20 : 28).fill(''));
  };

  const [isZeStart, setIsZeStart] = useState(true); // default: Ze start


  const handleInputChange = (index, value) => {
    const newPoemUnits = [...poemUnits];
    newPoemUnits[index] = value;
    setPoemUnits(newPoemUnits);
  };

const renderPoemInputs = () => {
  const lineUnits = isFiveWordLine ? 5 : 7;
  const totalLines = 4;

  // Pattern definitions
  const fiveWordPingStart = [
    '○/●', '○', '○/●', '●', '○',
    '○/●', '●', '○/●', '○', '○',
    '○/●', '●', '○/●', '○', '●',
    '○/●', '○', '○/●', '●', '○'
  ];

  const fiveWordZeStart = [
    '○/●', '●', '○/●', '○', '○',
    '○/●', '○', '○/●', '●', '○',
    '○/●', '○', '○/●', '●', '●',
    '○/●', '●', '○/●', '○', '○'
  ];

  const sevenWordPingStart = [
    '○/●', '○', '○/●', '●', '○/●', '○', '○',
    '○/●', '●', '○/●', '○', '○/●', '●', '○',
    '○/●', '●', '○/●', '○', '○/●', '●', '●',
    '○/●', '○', '○/●', '●', '○/●', '○', '○'
  ];

  const sevenWordZeStart = [
    '○/●', '●', '○/●', '○', '○/●', '●', '○',
    '○/●', '○', '○/●', '●', '○/●', '○', '○',
    '○/●', '○', '○/●', '●', '○/●', '○', '●',
    '○/●', '●', '○/●', '○', '○/●', '●', '○'
  ];

  // Select pattern array based on toggles
  const patternArray = isFiveWordLine
    ? (isZeStart ? fiveWordZeStart : fiveWordPingStart)
    : (isZeStart ? sevenWordZeStart : sevenWordPingStart);

  // Build poem input grid
  const lineBreaks = [];
  for (let i = 0; i < totalLines; i++) {
    const units = [];
    for (let j = 0; j < lineUnits; j++) {
      const index = i * lineUnits + j;
      units.push(
        <div key={`unit-${i}-${j}`} className={GongshiStyles.unitContainer}>
          <div className={GongshiStyles.symbolWrapper}>
              {patternArray[index]?.includes('/') ? (
                <>
                  <div className={GongshiStyles.toneCircleRow}>
                    {patternArray[index].split('/').map((tone, i) => (
                      <div
                        key={i}
                        className={`${GongshiStyles.toneCircle} ${tone === '●' ? GongshiStyles.ze : GongshiStyles.ping}`}
                      ></div>
                    ))}
                  </div>
                  <div className={GongshiStyles.toneLabel}>Ping / Ze</div>
                </>
              ) : (
                <>
                  <div
                    className={`${GongshiStyles.toneCircle} ${patternArray[index] === '●' ? GongshiStyles.ze : GongshiStyles.ping}`}
                  ></div>
                  <div className={GongshiStyles.toneLabel}>
                    {patternArray[index] === '●' ? 'Ze' : 'Ping'}
                  </div>
                </>
              )}
            </div>


          <input
            type="text"
            value={poemUnits[index]}
            onChange={(e) => handleInputChange(index, e.target.value)}
            className={GongshiStyles.unitBox}
            placeholder={index === 0 ? placeholderText : ''}
            onFocus={() => index === 0 && setPlaceholderText('')}
          />
        </div>
      );

      // Insert spacing (gaps)
      if (isFiveWordLine && j === 1) {
        units.push(<div key={`gap-${i}-${j}`} className={GongshiStyles.gap}></div>);
      } else if (!isFiveWordLine && (j === 1 || j === 3)) {
        units.push(<div key={`gap-${i}-${j}`} className={GongshiStyles.gap}></div>);
      }
    }

    lineBreaks.push(
      <div key={`line-${i}`} className={GongshiStyles.line}>
        {units}
      </div>
    );
  }

  return lineBreaks;
};


  const formatPoem = () => {
    const lineUnits = isFiveWordLine ? 5 : 7;
    const totalLines = 4;
    let poem = '';

    for (let i = 0; i < totalLines; i++) {
      const line = poemUnits.slice(i * lineUnits, (i + 1) * lineUnits).join(' ');
      poem += line + '\n';
    }

    return poem.trim();
  };

  const handleSubmission = async (type) => {
    const poem = submittedPoem.trim() || formatPoem();
  
    setIsLoading(true);
    setErrorMessage('');
    setSuccessMessage('');
    try {
      const endpoint = type === 'manual' ? 'manual-poem-submission' : 'assess-poem';
      const payload = {
        poem: poem,
        user_level: currentLevel,
        level: 'Gongshi', // Specify the level as Gongshi
      };
  
      const token = localStorage.getItem('token');
      const headers = {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` }),
      };
  
      const response = await fetch(`${API_URL}/${endpoint}`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(payload),
      });
  
      const data = await response.json();
  
      if (response.ok && data.is_valid) {
        if (type === 'manual') {
          setSuccessMessage(data.message || 'Poem submitted for manual review.');
        } else {
          setAssessmentResult(data.model_assessment); // Display AI feedback
          setPingZeFeedback(data.ping_ze_feedback || 'No Ping/Ze feedback available'); // Capture Ping/Ze feedback
          if (isLoggedIn && !hasGongshiBadge) {
            setShowBadgePrompt(true);
          }
        }
      } else {
        setErrorMessage(data.feedback || 'Failed to submit poem.');
        setAssessmentResult('');
        setPingZeFeedback('');
      }
    } catch (error) {
      console.error('Error submitting poem:', error);
      setErrorMessage('Error submitting poem.');
      setPingZeFeedback('');
    }
    setIsLoading(false);
  };
  
  
  
  const fetchUserLevel = async (token) => {
    try {
      const response = await fetch(`${API_URL}/user/current-level`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setCurrentLevel(data.level);
  
      if (data.achievements && data.achievements.Gongshi) {
        setHasGongshiBadge(true);
      }
    } catch (error) {
      console.error('Error fetching user level:', error);
    }
  };
  
  const openSubmissionsModal = () => {
    setIsModalOpen(true);
    const token = localStorage.getItem('token');
    if (token) {
      fetchSubmissions(token);
    }
  };

  const handleBadgeSubmission = async (passed) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('No token found. Please log in again.');
      }

      if (passed) {
        const response = await fetch(`${API_URL}/user/achievements/gongshi`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({ level: 'Gongshi' }),
        });

        if (response.ok) {
          setShowConfetti(true);
          setCurrentLevel('Gongshi');
          setHasGongshiBadge(true);
          setTimeout(() => {
            closeConfetti();
          }, 10000);
        } else {
          console.error('Failed to update user level.');
        }
      } else {
        setErrorMessage('Try again and make your poem better based on the assessment feedback.');
      }
    } catch (error) {
      console.error('Error updating user level:', error);
    }
    setShowBadgePrompt(false);
  };

  const closeConfetti = () => {
    setShowConfetti(false); // Hide the confetti
    window.location.reload(); // Reload the page immediately
  };

  const fetchSubmissions = async (token) => {
    try {
      const response = await fetch(`${API_URL}/submissions/?level=Gongshi`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
      const data = await response.json();

      if (Array.isArray(data)) {
        setSubmissions(data);
      } else {
        setSubmissions([]);
      }
    } catch (error) {
      console.error('Error fetching submissions:', error);
      setSubmissions([]);
    }
  };

  const handleReadMore = (submission) => {
    setSelectedSubmission(submission);
  };

  const renderPoemWithLineBreaks = (poem) => {
    if (!poem) {
      return <span>No poem provided.</span>;
    }

    const lines = poem.split('\n');
    return lines.map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index !== lines.length - 1 && <br />}
      </React.Fragment>
    ));
  };

  const renderSubmissionsModal = () => (
    <div className={`${GongshiStyles.modal} ${isModalOpen ? GongshiStyles.modalOpen : ''}`}>
      <div className={GongshiStyles.modalContent}>
        <span className={GongshiStyles.closeButton} onClick={() => setIsModalOpen(false)}>&times;</span>
        <h3>Your Submissions</h3>
        {Array.isArray(submissions) && submissions.length === 0 ? (
          <p>No submissions yet.</p>
        ) : (
          <div className={GongshiStyles.submissionsContainer}>
            {Array.isArray(submissions) && submissions.map((submission, index) => (
              <div key={index} className={GongshiStyles.submissionItem}>
                <p><strong>Poem:</strong> {renderPoemWithLineBreaks(submission.poem)}</p>
                <p>
                  <strong>Feedback:</strong>
                  {submission.submission_type === 'manual' && submission.status === 'finished' ? (
                    submission.feedback || 'No feedback available'
                  ) : submission.submission_type === 'manual' && submission.status !== 'finished' ? (
                    <span className={GongshiStyles.pending}>Pending</span>
                  ) : submission.model_assessment.length > 100 ? (
                    <>
                      {submission.model_assessment.slice(0, 100)}...
                      <span
                        className={GongshiStyles.readMore}
                        onClick={() => handleReadMore(submission)}
                      >
                        Read More
                      </span>
                    </>
                  ) : (
                    submission.model_assessment || 'No feedback available'
                  )}
                </p>
                <p><strong>Type:</strong> {submission.submission_type}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );

  const renderReadMoreModal = () => (
    selectedSubmission && (
      <div className={`${GongshiStyles.modal} ${GongshiStyles.modalOpen}`} style={{ zIndex: 1100 }}>
        <div className={GongshiStyles.readMoreModalContent}>
          <span className={GongshiStyles.closeButton} onClick={() => setSelectedSubmission(null)}>&times;</span>
          <h3>Submission Details</h3>
          <p className={GongshiStyles.poem}><strong>Poem:</strong> {renderPoemWithLineBreaks(selectedSubmission.poem)}</p>
          <p className={GongshiStyles.feedback}><strong>Feedback:</strong> {selectedSubmission.submission_type === 'ai' ? selectedSubmission.model_assessment : selectedSubmission.feedback || 'No feedback available'}</p>
          <p className={GongshiStyles.type}><strong>Type:</strong> {selectedSubmission.submission_type}</p>
          <p className={GongshiStyles.status}><strong>Status:</strong> {selectedSubmission.status}</p>
          <p className={GongshiStyles.submittedAt}><strong>Submitted At:</strong> {new Date(selectedSubmission.submitted_at).toLocaleString()}</p>
        </div>
      </div>
    )
  );

  const renderManualAssessmentPrompt = () => (
    isLoggedIn && (
      <div className={GongshiStyles.manualAssessmentContainer}>
        <p>If you want a manual assessment for more accuracy or if you disagree with the model, you can make a manual submission and receive feedback after a few days or weeks by the admin (check your submissions to see the feedback).</p>
        <button
          onClick={() => handleSubmission('manual')}
          disabled={isLoading}
          className={GongshiStyles.manualButton}
          title="Your submission will be sent for manual review."
        >
          Submit for Manual Assessment
        </button>
      </div>
    )  
  );

  const renderBadgePrompt = () => (
    <div className={GongshiStyles.badgePrompt}>
      <h4>Did you pass the Gongshi level?</h4>
      <button className={GongshiStyles.button} onClick={() => handleBadgeSubmission(true)}>Yes</button>
      <button className={GongshiStyles.button} onClick={() => handleBadgeSubmission(false)}>No</button>
    </div>
  );

  return (
    <div className={GongshiStyles.container}>
      {showConfetti && (
        <ConfettiPopup
          message="Congratulations! You now have a Gongshi badge!"
          onClose={closeConfetti}
        />
      )}
      <button onClick={openSubmissionsModal} className={`${GongshiStyles.openModalButton} ${GongshiStyles.button}`}>
        View Previous Submissions
      </button>
      <h2>Test a Regulated Poem</h2>
      
      <div className={GongshiStyles.imageRow}>
        <img
          src={FiveWord}
          alt="Left"
          className={GongshiStyles.PingzeImage}
        />
        <img
          src={SevenWord}
          alt="Right"
          className={GongshiStyles.PingzeImage}
        />
      </div>

      
      <div className={GongshiStyles.verticalToggles}>
        <div className={GongshiStyles.toggleRow}>
          <span className={GongshiStyles.toggleLabel}>{isFiveWordLine ? '5-word per line' : '7-word per line'}</span>
          <label className={GongshiStyles.switch}>
            <input type="checkbox" checked={!isFiveWordLine} onChange={handleToggle} />
            <span className={`${GongshiStyles.slider} ${GongshiStyles.round}`}></span>
          </label>
        </div>
        

        <div className={GongshiStyles.toggleRow}>
          <span className={GongshiStyles.toggleLabel}>{isZeStart ? 'Ze Start' : 'Ping Start'}</span>
          <label className={GongshiStyles.switch}>
            <input type="checkbox" checked={!isZeStart} onChange={() => setIsZeStart(!isZeStart)} />
            <span className={`${GongshiStyles.slider} ${GongshiStyles.round}`}></span>
          </label>
        </div>
      </div>



      <div className="flex items-start justify-center gap-4">
  {/* Left Image */}
  

  {/* Poem Input Section */}
  <div className="flex flex-col items-center">
    <p>Type in unit by unit:</p>
    {renderPoemInputs()}
    <p>OR</p>
    <p>Drop your whole poem</p>
    <textarea
      placeholder={"Enter your poem here...\n\nNote: Please remove all punctuation from your poem including apostrophes!"}
      value={submittedPoem}
      onChange={(e) => setSubmittedPoem(e.target.value)}
      className={GongshiStyles.textArea}
    />
  </div>
</div>

      <div className={GongshiStyles.submitButtonsContainer}>
        <button
          onClick={() => handleSubmission('ai')}
          disabled={isLoading}
          className={`${GongshiStyles.aiButton} ${GongshiStyles.button}`}
          title="You will receive an instant AI assessment."
        >
          Submit for AI Assessment
        </button>
      </div>
      {isLoading && <div className={GongshiStyles.loader}></div>}
      {errorMessage && <div className={GongshiStyles.errorMessage}>{errorMessage}</div>}
      {successMessage && <div className={GongshiStyles.successMessage}>{successMessage}</div>}
      {assessmentResult && (
        <div className={GongshiStyles.assessmentResult}>
          {assessmentResult}
          {!hasGongshiBadge && showBadgePrompt && renderBadgePrompt()}
          {renderManualAssessmentPrompt()}
        </div>
      )}
      {modelAssessment && (
        <div className={GongshiStyles.modelAssessment}>
          <h4>Model Assessment</h4>
          <p className={GongshiStyles.generatedText}>{modelAssessment}</p>
        </div>
        
      )}
      {pingZeFeedback && (
          <div className={GongshiStyles.pingZeFeedback}>
            <h4>Ping/Ze Analysis</h4>
            <pre>{pingZeFeedback}</pre>
          </div>
        )}
      {renderSubmissionsModal()}
      {renderReadMoreModal()}
    </div>
  );
};

export default Gongshi;

